export const jsonEmpty = (input) => {
    if (input === null || typeof input === 'undefined')
        return false;
    return Object.keys(input).length === 0 && input.constructor === Object;
}